import { config } from '@uhg-abyss/web/tools/config';

/**
 * Hook: useCurrentEnvironment
 *
 * Gets the current environment of the application.
 *
 * @returns {*}
 */
export const useCurrentEnvironment = () => {
  const environments = {
    dev: 'Development',
    local: 'Local',
    'local:build': 'Local',
    'local:dev': 'Local',
    prod: 'Production',
    stage: 'Stage',
  };

  return environments[config('APP_ENV')];
};
